import React, { ReactElement, useState } from "react";
import { gql, useQuery } from "urql";
import { useParams } from "wouter";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import { ChevronLeft, ChevronRight, Download } from "lucide-react";
import save from "save-file";

import { useContainerWidth } from "./PdfViewPage";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const getAttachment = gql`
    query getAttachment($_id: GraphQLObjectId!) {
        attachment(_id: $_id) {
            fileId
            fileName
            base64
            mimeType
        }
    }
`;

export const PdfViewPages = (): ReactElement => {
    const { id }: any = useParams();
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [containerRef, containerWidth] = useContainerWidth();

    const [{ fetching, error, data }] = useQuery({ query: getAttachment, variables: { _id: id } });

    if (fetching) return <p>Loading</p>;
    if (error) return <p>Error: {JSON.stringify(error, null, 2)}</p>;

    const attachment = data.attachment;
    const dataURI = "data:" + attachment.mimeType + ";base64," + attachment.base64;

    const handleDownload = () => {
        save(dataURI, attachment.fileName.replaceAll(" ", "_")).catch(console.error);
    };

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    return (
        <div className="w-full max-w-screen-2xl mx-auto pb-4">
            <div className="mb-4 d-flex justify-content-end">
                <button type="button" className="btn btn-primary mr-3" onClick={handleDownload}>
                    <Download size={16} className="mr-2" />
                    Download
                </button>
            </div>
            <div className="w-full min-w-0 overflow-x-hidden">
                <div ref={containerRef} className="h-0 w-full overflow-hidden" />
                {containerWidth > 0 ? (
                    <Document file={dataURI} onLoadSuccess={onDocumentLoadSuccess}>
                        <Page pageNumber={pageNumber} width={containerWidth} className="shadow-md" />
                    </Document>
                ) : null}
                <div className="mt-4 d-flex flex-wrap align-items-center justify-content-center gap-2">
                    <span className="mr-4">
                        Page {pageNumber} of {numPages}
                    </span>

                    {pageNumber > 1 ? (
                        <button
                            className="btn btn-light"
                            onClick={() => {
                                setPageNumber(pageNumber - 1);
                            }}
                        >
                            <ChevronLeft size={16} />
                        </button>
                    ) : null}

                    {pageNumber < numPages ? (
                        <button
                            className="btn btn-light"
                            onClick={() => {
                                setPageNumber(pageNumber + 1);
                            }}
                        >
                            <ChevronRight size={16} />
                        </button>
                    ) : null}
                </div>
            </div>
        </div>
    );
};
